<template>
  <div class="loading_container" v-if="is_load_on()">
    <div class="loading-spinner"></div>
  </div>
</template>
<script>
export default {
  computed: {
    state() {
      return this.$loading_state;
    }
  },
  methods: {
    is_load_on() {
      return this.state() > 0;
    }
  }
};
</script>
<style scoped>
.loading_container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(173, 223, 223, 0.322);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
}

.loading-spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left: 4px solid #3498db;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}</style>